module.exports = __webpack_public_path__ + "assets/img/11.4d0e6628.jpg";